// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--S__gH","heroBackground":"hero-module--heroBackground--3Qnn4","heroContent":"hero-module--heroContent--2Uvf1"};